import styles from "./styles.module.css";
const SmallPadding = () => {
  return <div className={styles.header} />;
};
export default SmallPadding;
